export default __webpack_public_path__ + "static/media/logo-horse.bf7f444a.svg";